import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Our Story',
    href: '#about'
  }, {
    name: 'How It Works',
    href: '/design'
  }, {
    name: 'Wines',
    href: '#collection'
  }, {
    name: 'Custom Labels',
    href: '/design#gallery'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }];
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    // If it's a route (starts with /), let React Router handle it
    if (href.startsWith('/')) {
      e.preventDefault();
      setIsMobileMenuOpen(false);
      navigate(href);
      return;
    }
    // Otherwise it's a hash link, handle smooth scrolling
    e.preventDefault();
    setIsMobileMenuOpen(false);
    if (location.pathname !== '/') {
      navigate('/' + href);
    } else {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  // Determine text color based on page and scroll state
  const isHomePage = location.pathname === '/';
  const textColorClass = isHomePage && !isScrolled && !isMobileMenuOpen ? 'text-white' : 'text-wine';
  const linkColorClass = isHomePage && !isScrolled ? 'text-white/90' : 'text-brown';
  const buttonClass = isHomePage && !isScrolled ? 'bg-white text-wine hover:bg-cream' : 'bg-wine text-white hover:bg-wine-700';
  return <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled || !isHomePage ? 'bg-cream/95 backdrop-blur-md shadow-subtle py-4' : 'bg-transparent py-6'}`} data-id="element-182">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-183">
        <div className="flex justify-between items-center" data-id="element-184">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 z-50" data-id="element-185">
            <span className={`font-playfair text-2xl font-bold tracking-tight transition-colors duration-300 ${textColorClass}`} data-id="element-186">
              Wine & Design
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-187">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link.href)} className={`text-sm font-medium transition-colors duration-300 hover:text-gold ${linkColorClass}`} data-id="element-188">
                {link.name}
              </a>)}
            <Link to="/design" className={`px-5 py-2.5 rounded-sm text-sm font-medium transition-all duration-300 ${buttonClass}`} data-id="element-189">
              Get Started
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center z-50" data-id="element-190">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className={`p-2 focus:outline-none transition-colors duration-300 ${textColorClass}`} aria-label="Toggle menu" data-id="element-191">
              {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-192" /> : <MenuIcon className="h-6 w-6" data-id="element-193" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div className={`fixed inset-0 bg-cream z-40 transition-transform duration-300 ease-in-out md:hidden ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-194">
        <div className="flex flex-col items-center justify-center h-full space-y-8 px-4" data-id="element-195">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link.href)} className="font-playfair text-3xl text-wine hover:text-gold transition-colors" data-id="element-196">
              {link.name}
            </a>)}
          <Link to="/design" onClick={() => setIsMobileMenuOpen(false)} className="mt-8 px-8 py-4 bg-wine text-white rounded-sm text-lg font-medium hover:bg-wine-700 transition-colors w-full max-w-xs text-center" data-id="element-197">
            Get Started
          </Link>
        </div>
      </div>
    </nav>;
}